import { Annotation } from '@readcloud/data';
import {
  ALL_ANNOTATIONS,
  FILTERING_ANNOTATIONS,
  NO_ANNOTATIONS,
} from '../types/TopToolbarConstants';

export const isAnnotationShared = (annotation?: {
  visibleInClouds: Annotation['visibleInClouds'];
  visibleToUsers: Annotation['visibleToUsers'];
}) =>
  !!(annotation?.visibleInClouds?.length || annotation?.visibleToUsers?.length);

//Additional Filtering
const filterAnnotationByType = (
  anno: Annotation,
  annotationFilterTypes: string,
  annotationFilterUser?: string[]
) => {
  if (
    anno.type &&
    annotationFilterTypes &&
    annotationFilterTypes.indexOf('|' + anno.type) > 0
  ) {
    if (
      annotationFilterTypes.indexOf(FILTERING_ANNOTATIONS) >= 0 &&
      annotationFilterUser == undefined
    ) {
      return false;
    }

    if (annotationFilterUser && !annotationFilterUser.includes(anno.author))
      return false;
    return true;
  } else if (anno.type && annotationFilterTypes) {
    return false;
  } else {
    return true;
  }
};

//Annotation Filtering Rules
export const filterAnnoByOptions = (
  anno: Annotation,
  annotationFilterTypes: string | undefined,
  annotationFilterUser?: string[]
) => {
  if (
    (anno.options &&
      anno.options.type === 'Publisher' &&
      anno.options.status === 'Published') ||
    (annotationFilterTypes &&
      annotationFilterTypes.indexOf(ALL_ANNOTATIONS) >= 0)
  ) {
    return anno; //Ensure all publisher annotations are shown
  } else if (
    annotationFilterTypes &&
    annotationFilterTypes.indexOf(FILTERING_ANNOTATIONS) >= 0
  ) {
    return filterAnnotationByType(
      anno,
      annotationFilterTypes,
      annotationFilterUser
    );
  } else if (
    annotationFilterTypes &&
    annotationFilterTypes.indexOf(NO_ANNOTATIONS) >= 0
  ) {
    return null;
  } else {
    //All Annotations
    return filterAnnotationByType(
      anno,
      annotationFilterTypes,
      annotationFilterUser
    );
  }
};
